import { FC } from "react";

import { mainTheme } from "@data/theme/theme";
import DefaultButton from "@ui/components/Button/DefaultButton";
import BackToTopButton from "@ui/components/Button/BackToTopButton/BackToTopButton";

import {
  GridSpacer,
  FooterButtonContainer,
  FooterContainer,
} from "./UsersFooterStyle";
import { useNavigate } from "react-router-dom";

const RenderFooter: FC = () => {
  const navigate = useNavigate();

  return (
    <FooterContainer>
      <BackToTopButton />
      <GridSpacer />
      <FooterButtonContainer>
        <DefaultButton
          backgroundColor={mainTheme.colors.primaryPositive}
          hoverColor={mainTheme.colors.primary}
          buttonText={"ユーザ削除"}
          size={"M"}
          color={mainTheme.colors.onPrimary}
          contentWidth="168px"
          onClick={() => {
            navigate("/users/delete");
          }}
        />
      </FooterButtonContainer>

      <GridSpacer />
    </FooterContainer>
  );
};

export default RenderFooter;
